export type TextPart = { readonly text: string; readonly href?: string };

const URL_PATTERN = /\b(?:https?:\/\/|www\.)[^\s<>"]+/gi;
const SENTENCE_PUNCTUATION = '.,;:!?\'"]}';

const count = (text: string, char: string): number => text.split(char).length - 1;

// Drops trailing sentence punctuation, and a closing paren the URL never opened
// (so "(see https://x.com/a)" links x.com/a but wikipedia.org/wiki/Foo_(bar) keeps its paren).
const trimTrailing = (url: string): string => {
  let trimmed = url;
  for (;;) {
    const last = trimmed[trimmed.length - 1];
    const dangling = SENTENCE_PUNCTUATION.includes(last) || (last === ')' && count(trimmed, ')') > count(trimmed, '('));
    if (!dangling) return trimmed;
    trimmed = trimmed.slice(0, -1);
  }
};

const toHref = (url: string): string => (url.toLowerCase().startsWith('www.') ? `https://${url}` : url);

/** Splits text into plain and linked parts; only http(s) and www. URLs become links. */
export const splitLinks = (text: string): readonly TextPart[] => {
  const parts: TextPart[] = [];
  let last = 0;
  for (const match of text.matchAll(URL_PATTERN)) {
    const url = trimTrailing(match[0]);
    const start = match.index ?? 0;
    if (start > last) parts.push({ text: text.slice(last, start) });
    parts.push({ text: url, href: toHref(url) });
    last = start + url.length;
  }
  if (last < text.length) parts.push({ text: text.slice(last) });
  return parts;
};
